import React, { forwardRef, memo, useRef } from "react";
import { Container } from "react-bootstrap";
import { m } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { fadeIn } from "../../../../utils/GlobalAnimations";
import Utils from "../../../../utils/Utils";
import "../../../../assets/scss/components/_clients.scss";

const ClientLogos = forwardRef((props, ref) => {
  const { items, parent } = props;
  const swiperRef = useRef(null);
  const cl = Utils.isValidJson(parent.className)
    ? JSON.parse(parent.className)
    : parent.className;

  return (
    <section
      ref={ref}
      className="py-[130px] lg:py-[90px] md:py-[75px] sm:py-[50px]"
      style={{ ...cl }}
    >
      <Container>
        <m.div
          className="client-slider-wrapper relative swiper-navigation-04 swiper-navigation-light"
          {...fadeIn}
        >
          <Swiper
            ref={swiperRef}
            slidesPerView={4}
            spaceBetween={20}
            loop={true}
            className="client-logo-style-03"
            modules={[Autoplay]}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            breakpoints={{
              992: { slidesPerView: 4 },
              768: { slidesPerView: 3 },
              480: { slidesPerView: 2 },
            }}
          >
            {items.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="client-box">
                  <a
                    aria-label="clientlogo"
                    href={item?.content?.link || "#"}
                    target={item?.content?.target || "_self"}
                  >
                    {item?.content?.image_main && (
                      <img
                        width="148"
                        height="43"
                        src={Utils.formatURL(
                          `posts/${item?.post_content_id}/${item?.content?.image_main}?s=md`,
                        )}
                        alt="clientlogo"
                      />
                    )}
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            onClick={() => swiperRef.current.swiper.slidePrev()}
            className="swiper-button-prev absolute"
          ></div>
          <div
            onClick={() => swiperRef.current.swiper.slideNext()}
            className="swiper-button-next absolute"
          ></div>
        </m.div>
      </Container>
    </section>
  );
});

export default memo(ClientLogos);
